export default {
  pageNotFound: {
    text1: 'We couldn’t find the page you’re looking for!',
    link: 'Return to the home page',
    text2: 'or view our content ↓',
  },
}
